import { useEffect, useState } from "react";
import { SelectOption } from "components/AntDesign/Select/BaseSelect";
import { workSessionService } from "../api/work-session.service";
import { WorkSessionCategory } from "../model";

export function useWorkSessionCategories() {
  const [options, setOptions] = useState<SelectOption<number>[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);

      try {
        const categories = await workSessionService.getWorkSessionsCategory();

        if (cancelled) return;

        const mapped: SelectOption<number>[] = categories.map(
          (c: WorkSessionCategory) => ({
            value: c.id,
            label: c.name,
          }),
        );

        setOptions(mapped);
      } catch (err) {
        console.error("Failed to load categories", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    options,
    loading,
  };
}
